import { Typography, Descriptions, Space } from "antd";
import moment from "moment";

const labelColor = {
  color: "grey",
};

export function SubgraphInfo({ project, subgraph, indexingStatus }: any) {
  return subgraph ? (
    <Space direction="horizontal">
      <Descriptions layout="vertical" colon={false} column={4} size="small">
        <Descriptions.Item label="Cluster" labelStyle={labelColor}>
          <Typography.Text>{subgraph.cluster}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="ID" labelStyle={labelColor}>
          <Typography.Text copyable>{subgraph.id}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Project" labelStyle={labelColor}>
          <Typography.Text copyable>{project.name}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Created" labelStyle={labelColor}>
          <Typography.Text>{moment(subgraph.createdAt).fromNow()}</Typography.Text>
        </Descriptions.Item>

        {indexingStatus?.queryUrl ? (
          <Descriptions.Item label="Query URL" labelStyle={labelColor} span={4}>
            <Typography.Text copyable>{indexingStatus?.queryUrl}</Typography.Text>
          </Descriptions.Item>
        ) : null}
        {indexingStatus ? (
          <Descriptions.Item label="Subgraph version ID" labelStyle={labelColor}>
            <Typography.Text copyable>{indexingStatus.subgraph}</Typography.Text>
          </Descriptions.Item>
        ) : null}
      </Descriptions>
    </Space>
  ) : null;
}
